import Controller, { OnBeforeSubmit, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import moment from 'moment';
import { ISO_DATE_FORMAT } from '@philips-internal/oswald-ui-model/lib/formatters/date/date-utils';
import { FragmentNames, HydricBalanceAliases } from '../../../codegen';
import { DateFilterUtils } from '../../../utils/date-filter-utils';
import BaseController from '../../BaseController';
import { CarouselAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import { IntakesAndPutsContext } from '../../intakes-and-outputs/intakes-and-outputs-service';
import { Value } from '@philips-internal/oswald-ui-core';

import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import ShowToast from '../../../utils/toast-service';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

@Controller({ component: HydricBalanceAliases.HYDRIC_BALANCE_LAYOUT, fragment: FragmentNames.HYDRIC_BALANCE })
class HydricBalanceViewerController extends BaseController {

  @Inject(HydricBalanceAliases.HYDRIC_BALANCE_CAROUSEL)
  carouselApi!: CarouselAPI;

  @OnMount({ target: HydricBalanceAliases.HYDRIC_BALANCE_FILTER })
  OnFilterMount(event: MountEvent): void {
    const { currentDate } = DateFilterUtils.getDateRange();
    const record = {
      finalDate: currentDate,
      initialDate: moment().subtract(1, 'months').format(ISO_DATE_FORMAT),
    };

    IntakesAndPutsContext.setInternalNavegation(false);

    const filter = event.target as FilterAPI;
    const state = IntakesAndPutsContext.get();

    if (state) {
      Object.assign(record, state);
    }

    filter.setData(record);
    filter.submit();
  }

  @OnUnmount(HydricBalanceAliases.HYDRIC_BALANCE_FILTER)
  onUnmountFilter(event: MountEvent): void {
    const filter = event.target as FilterAPI;
    IntakesAndPutsContext.set(filter.getRecord() as Record<string, Value>)
  }

  @OnBeforeSubmit({ target: HydricBalanceAliases.HYDRIC_BALANCE_FILTER })
  handleFilterHydricBalanceBeforeSubmit(event: SubmitEvent) : void {
    const dateLimit = 90;
    if(DateFilterUtils.diffDate(event.record.finalDate, event.record.initialDate) > dateLimit) {
      ShowToast.open(MessageService.translate('text.message.more-ninety-days'), ToastLevel.CAUTION);
    }
  }
}

export default HydricBalanceViewerController;
